module.exports = __webpack_public_path__ + "img/goal-ten-br.01ecb5f3.png";